import { Type } from "class-transformer"
import {
  ArrayNotEmpty,
  IsArray,
  IsNotEmpty,
  IsObject,
  IsString,
  ValidateNested,
} from "class-validator"
import { Currency } from "~/currencies/currency.model"
import { IsNullable } from "~/utils/utils.validation"

export class Region {
  @IsNotEmpty()
  @IsString()
  readonly _id: string

  @IsNotEmpty()
  @IsString()
  readonly name: string

  @IsString()
  @IsNullable()
  readonly acronym: string | null

  @ValidateNested({ each: true })
  @Type(() => RegionCountry)
  @ArrayNotEmpty()
  @IsArray()
  readonly countries: RegionCountry[]
}

export class RegionCountry {
  @IsNotEmpty()
  @IsString()
  _id: string

  @IsNotEmpty()
  @IsString()
  name: string

  @IsString()
  @IsNullable()
  acronym: string | null

  @ValidateNested()
  @Type(() => Currency)
  @IsObject()
  currency: Currency

  @IsNotEmpty()
  @IsString()
  unicodeFlag: string

  @IsNotEmpty()
  @IsString()
  code: string
}
